<script setup>
</script>
<template>
  <div class="w-full h-screen flex items-center justify-center bg-white">
    <div class="flex justify-center w-full max-w-[800px]">

    </div>
  </div>
</template>
